import { Component, Input } from '@angular/core'
import { IonicModule } from '@ionic/angular'
import { NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common'
import { TranslateModule } from '@ngx-translate/core'
import { IconInformationComponent } from '../event-detail/icon-information.component'
import { RedirectionToEventComponent } from './redirection-to-event/redirection-to-event.component'
import { LiveEvent } from '../../../../core/models/live-events'

@Component({
  selector: 'app-event-summary',
  standalone: true,
  imports: [IonicModule, TranslateModule, IconInformationComponent, RedirectionToEventComponent, NgSwitch, NgSwitchDefault, NgSwitchCase],
  template: `
    <ng-container [ngSwitch]="event.type">
      <app-redirection-to-event *ngSwitchCase="'INCIDENT'" [incident]="event" />
      <app-icon-information *ngSwitchDefault [event]="event" />
    </ng-container>`
})
export class EventSummaryComponent {
  @Input() event: LiveEvent
}
